import { Routes, Route } from 'react-router-dom';

import {
  ChatPage,
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  LicensePage,
  AccountPage,
  DashboardPage,
  BackupPage,
} from '../pages';
import ProtectedRoute from './ProtectedRoute';
import RedirectAdmin from './RedirectAdmin';

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/:sessionId?/:userUid?"
        element={
          <RedirectAdmin>
            <ChatPage />
          </RedirectAdmin>
        }
      />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/license" element={<LicensePage />} />
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <AccountPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/:userUid?"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/backup"
        element={
          <RedirectAdmin requireAdmin>
            <BackupPage />
          </RedirectAdmin>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
